<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2 v-if="status">Set inactive</h2>
            <h2 v-else>Set active</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong v-if="status">Are you sure you want to set this chat as inactive?</strong>
                <strong v-else>Are you sure you want to set this chat as active?</strong>
            </p>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <a v-if="status"
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click="onChangeState"
                >
                    Set inactive
                </a>
                <a v-else
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click="onChangeState"
                >
                    Set active
                </a>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        changeStateUrl: {
            required: true,
        },
        status: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        onCancel() {
            this.$emit('close');
        },
        onChangeState() {
            this.axios.post(this.changeStateUrl)
                .then(({ data }) => {
                    this.$emit('changeState');
                    window.showToastSuccess('Successfully set.');
                })
                .catch((err) => {
                    window.showToastError('An error occured! Please try again.');
                });
            this.$emit('close');
        },
    },
};
</script>
